import { render } from "./LogsStatistics.vue?vue&type=template&id=9145fc62&scoped=true"
import script from "./LogsStatistics.vue?vue&type=script&lang=js"
export * from "./LogsStatistics.vue?vue&type=script&lang=js"

import "./LogsStatistics.vue?vue&type=style&index=0&id=9145fc62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9145fc62"]])

export default __exports__